import SEO from "@/components/SEO";
import FAQAccordion from "@/components/FAQAccordion";
import { RelatedLinks } from "@/pages/ServicePage";
import { PageHero, SectionHead, CTABand, Reveal } from "@/components/Ui";

const prestations = [
  { t: "Dalles béton", d: "Dalles pour maisons, garages, abris et extensions." },
  { t: "Chapes", d: "Chapes de finition prêtes à recevoir carrelage ou revêtement." },
  { t: "Terrasses béton", d: "Béton lissé, balayé ou désactivé, adapté à votre usage." },
  { t: "Allées béton", d: "Allées carrossables et piétonnes, durables et propres." },
  { t: "Pavés et bordures", d: "Pose de pavés, bordures et caniveaux pour structurer vos extérieurs." },
  { t: "Murets et clôtures", d: "Murets de clôture, piliers de portail et ouvrages maçonnés." },
  { t: "Escaliers béton", d: "Escaliers extérieurs coulés sur mesure." },
];

const faq = [
  { q: "Quels aménagements extérieurs réalisez-vous ?", a: "Terrasses, allées, dalles, pavés, bordures, murets, clôtures maçonnées et escaliers béton, à Bernay, Évreux et dans l'Eure." },
  { q: "Béton lissé ou désactivé : que choisir ?", a: "Le lissé offre un rendu uni et contemporain, le désactivé un aspect texturé et antidérapant. Nous vous conseillons selon l'usage et le budget." },
  { q: "Réalisez-vous les clôtures en maçonnerie ?", a: "Oui : murets, murs de clôture et piliers de portail, avec fondations et enduits de finition." },
];

export default function BetonExterieurs() {
  return (
    <>
      <SEO
        title="Dalles & terrasses béton à Bernay | DMZ Normandie"
        description="Dalles béton, chapes, terrasses, allées, pavés, murets et clôtures à Bernay, Évreux et dans l'Eure. DMZ Normandie — devis gratuit, 07 45 04 91 89."
        path="/beton-amenagements-exterieurs"
      />
      <PageHero
        title="Béton et aménagements extérieurs"
        subtitle="Dalles, terrasses, allées, murets : DMZ Normandie réalise vos ouvrages en béton et vos aménagements extérieurs à Bernay, Évreux et dans toute l'Eure."
      />

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-20">
            <Reveal delay={0.05}>
              <div className="overflow-hidden relative">
                <img src="/realisations/terrasse-beton.webp" alt="Terrasse en béton réalisée par DMZ Normandie dans l'Eure" className="w-full h-80 object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-black/25" />
              </div>
            </Reveal>
            <Reveal>
              <SectionHead overline="Extérieurs" title="Des extérieurs propres et durables" />
              <p className="-mt-6 text-zinc-400 font-light leading-relaxed">
                Le béton offre une base solide et durable pour vos extérieurs. Nous préparons soigneusement
                chaque ouvrage : terrassement, coffrage, ferraillage, coulage et finition. Le résultat :
                une surface plane, propre et pensée pour durer, de la terrasse familiale à l'allée carrossable.
              </p>
            </Reveal>
          </div>

          <SectionHead overline="Nos prestations" title="Tous les ouvrages en béton" center />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {prestations.map((p, i) => (
              <Reveal key={p.t} delay={(i % 3) * 0.06} className="card-dark p-7">
                <h3 className="font-medium text-[#F5F5F0] mb-2">{p.t}</h3>
                <p className="text-sm font-light text-zinc-500 leading-relaxed">{p.d}</p>
              </Reveal>
            ))}
          </div>

          <div className="max-w-4xl mx-auto mt-20">
            <SectionHead overline="Questions fréquentes" title="Vos questions, nos réponses" />
            <FAQAccordion items={faq} testid="faq-beton" />
          </div>

          <div className="mt-16">
            <Reveal>
              <p className="text-[10px] tracking-[0.5em] uppercase text-[#C4A484] mb-5">Voir aussi</p>
              <RelatedLinks slugs={["dalles-beton", "fondations", "construction-murs", "maconnerie-bernay"]} />
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand />
    </>
  );
}
